import Crud from "../Crud";
import MUIBlueColor from "@mui/material/colors/blue";

/**
 * Static helper functions related to widgets.
 */
export default class Widget extends Crud {
    /**
     * @param {object} widget The widget object.
     * @returns The display name of the widget.
     */
    static getDisplayName(widget) {
        return widget.name;
    }

    /**
     * Determines if a widget matches a search query.
     *
     * @param {object} widget The widget to test.
     * @param {string} query The search query.
     * @returns {boolean} Whether or not the widget matches the query.
     */
    static match(widget, query) {
        return (
            (widget.name && widget.name.toLowerCase().includes(query)) ||
            widget.id === +query
        );
    }

    /**
     * @param {array} widgets The list to sort.
     * @returns {array} The sorted list.
     */
    static sort(widgets) {
        return widgets.sort((a, b) => {
            return (a.name || "").localeCompare(b.name || "");
        });
    }

    /**
     * @returns {string} The color of this object.
     */
    static getBaseColor() {
        return MUIBlueColor;
    }

    /**
     * @returns {string} The icon name for this object.
     */
    static getIconName() {
        return "Widgets";
    }
}
